import React, { useEffect, useState }  from 'react'
import { Link } from 'react-router-dom'
import { ArrepentimientoModal } from "../home/bloques/ArrepentimientoModal";
import { useRazonSocial } from "../../utils/razonSocial";

export const Footer = () => {
    const razonSocial = useRazonSocial();
    const [info, setinfo] = useState(null)
    useEffect(() => {
        fetch("/config_generales")
            .then(res => res.json())
            .then(result => {
               setinfo(result)
            });
    }, []);

    let handleOpen = () => {
        let backdrop = document.querySelector(".form-modalBackdrop");
        backdrop.style.opacity = "1";
        backdrop.style.zIndex = "99999";

        let form = document.querySelector(".form-modalScreen");
        form.style.opacity = "1";
        form.style.zIndex = "999999";

        document.getElementById("cuit-focus").focus();
    };

    let handleClose = () => {
        let backdrop = document.querySelector(".form-modalBackdrop");
        backdrop.style.opacity = "0";
        backdrop.style.zIndex = "-1";

        let form = document.querySelector(".form-modalScreen");
        form.style.opacity = "0";
        form.style.zIndex = "-1";
    };

    return (
        <footer className="footer">
            <div className="footer--container">
                <div className="separator--hor mb-base"></div>
                <div className="footer--container_info">
                    <div className="innerDiv">
                        <Link className="link--footer" to={'/acto_de_adjudicacion'}><img src="/images/icons/arrow-right.svg" />
                            <h2>Acto de adjudicación</h2>
                        </Link>
                        <Link className="link--footer" to={'/conoce_fiat_plan'}><img src="/images/icons/arrow-right.svg" />
                            <h2>Conocé Fiat Plan</h2>
                        </Link>

                        <Link className="link--footer" to={'/preguntas_frecuentes'}><img src="/images/icons/arrow-right.svg" />
                            <h2>Preguntas frecuentes</h2>
                        </Link>

                        <Link className="link--footer" to={'/informacion_general'}><img src="/images/icons/arrow-right.svg" />
                            <h2>Información general</h2>
                        </Link>

                        <div className="link--footer" style={{cursor: "pointer"}} onClick={handleOpen}><img src="/images/icons/arrow-right.svg" />
                            <h2>Arrepentimiento</h2>
                        </div>

                        <ArrepentimientoModal handleClose={handleClose} />

                    </div>
                    <div className="innerDiv">
                        <Link className="link--footer" to={'/gastos_de_entrega'}><img src="/images/icons/arrow-right.svg" />
                            <h2>Gastos de Entrega</h2>
                        </Link>

                        <a className="link--footer" target="_blank" href='https://www.fiat.com.ar/concesionarios.html'><img src="/images/icons/arrow-right.svg" /><h2>Concesionarios</h2></a>

                        <Link className="link--footer" to={'/terminos_y_condiciones'}><img src="/images/icons/arrow-right.svg" /><h2>Términos y condiciones</h2></Link>

                        <h2>Sede Social</h2>
                        <h2 className="no-uppercase"> {info !== null && info.direccion_footer}</h2>


                    </div>
                    <div className="innerDiv py-half py-xl-0">
                        <h2 className="">Atención Clientes Fiat Plan</h2>
                        <a href={`tel:${info !== null && info.telefono_footer}`}><h1>{info !== null && info.telefono_footer}</h1></a>
                        <a href={`mailto:${info !== null && info.email_footer}`}>{info !== null && info.email_footer}</a>
                    </div>

                    <div className="innerDiv pt-half pt-xl-0 ">
                        <div className="d-flex row innerDiv--main">
                            <div className="col-8">
                                <p className="text-gray">Copyright © {razonSocial.minusculas}. Todos los derechos reservados.</p>
                            </div>
                            <div className="col-4 d-flex justify-content-end">
                                <a target="_blank" href="https://serviciosweb.afip.gob.ar/clavefiscal/qr/publicInfoD.aspx"><img className="dataFiscal" src="/images/icons/footer.png" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
